import { IApplicationContext } from '../../types/applicationContext';
import { ResponseError } from 'shared/errors';

import {
  TDeleteOfferFromComparisonRequest,
  TDeleteOfferFromComparisonResponse,
  fetchDeleteOfferFromComparison,
} from 'shared/repositories/offers-comparison/v1/delete-offer-from-comparison';

export const deleteFromComparison = async (
  { httpApi, logger }: IApplicationContext,
  parameters: TDeleteOfferFromComparisonRequest,
) => {
  try {
    const { response, statusCode }: TDeleteOfferFromComparisonResponse = await fetchDeleteOfferFromComparison({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'deleteFromComparison',
        message: response.message || '',
        details: {
          errors: JSON.stringify(response.errors),
        },
      });
    }

    return response;
  } catch (e) {
    logger.error(e, {
      domain: 'deleteFromComparison',
      parameters: JSON.stringify(parameters),
    });

    return null;
  }
};
